import { alertConstants } from "./types";
import { REHYDRATE } from "redux-persist";

const initialState = { message: null };

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return initialState;
    case alertConstants.SUCCESS:
      return {
        ...state,
        isOpen: true,
        type: "success",
        message: action.message,
        redirect: action.redirect,
        status: 200,
        isSuccess: true,
      };
    case alertConstants.ERROR:
      return {
        ...state,
        isOpen: true,
        type: "error",
        message: action?.message?.response?.data,
        status: action?.message?.response?.status,
      };
    case alertConstants.SHOW_ERROR:
      return {
        ...state,
        isOpen: true,
        type: "error",
        message: action?.message,
      };
    case alertConstants.CLEAR:
      return {};
    case alertConstants.SHOW_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case alertConstants.HIDE_MODAL:
      return {};
    case alertConstants.SHOW_LOADING:
      return {
        ...state,
        loading: true,
      };
    case alertConstants.HIDE_LOADING:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
